import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { useCopies } from "shared/hooks/useCopies";
import { successToast } from "shared/utils/toastNotification";
import { usePostApiData } from "shared/datalayer";
import { ApiRegistrationParticipantForParticipantResponse } from "shared/types/ApiRegistrationParticipantForParticipantResponse";
import { ApiRegRequest } from "../../../../../console/modules/registration/approval/details/types";

export function useAssignTicket({ successHandler }: { successHandler: () => void }) {
  const copies = useCopies();
  return usePostApiData<ApiRegistrationParticipantForParticipantResponse, ApiRegRequest>(
    MyExpApi.INITIATE_TICKET_ASSIGNMENT,
    {
      onSuccess: () => {
        successToast(copies.get("bulk.ticket.assigned.successfully"));
        successHandler();
      }
    }
  );
}

export function useAssignTicketToNonAttendee({ successHandler }: { successHandler: () => void }) {
  const copies = useCopies();
  return usePostApiData<ApiRegistrationParticipantForParticipantResponse, ApiRegRequest>(
    MyExpApi.ASSIGN_TICKET_TO_NON_ATTENDEE,
    {
      onSuccess: () => {
        successToast(copies.get("bulk.ticket.assigned.successfully"));
        successHandler();
      }
    }
  );
}
